import React, { useRef } from "react"
import isNumeric from "validator/lib/isNumeric"
import { useTranslation } from "react-i18next"

import { getUserList } from "services"
import { Select } from "components"
import { formatMobilePhone, haveAuth } from "utils"
import classes from "./OfsUserSelect.module.scss"

const OfsUserSelect = props => {
  const {
    form,
    setForm,
    initialUsersList,
    setInitialUsersList
  } = props

  const [t] = useTranslation()

  const timeout = useRef(null)
  const unmount = useRef(false)

  const handleSelect = (select) => {
    setForm(prev => ({ ...prev, account: select }))
  }


  const getInitialUsersList = async () => {
    if (initialUsersList !== null) return

    if (!haveAuth(["viewOtherAccessesOrders"])) return

    try {
      const { data } =
        await getUserList({ limit: 5, role: "user" })

      if (unmount.current) return

      setInitialUsersList(
        data.map(user => ({
          value: user._id,
          label: `${user.fullName} (${formatMobilePhone(user.mobilePhone)})`
        }))
      )

    } catch (err) {
      console.log(err)
    }
  }

  const handleSearch = (inputValue, callback) => {
    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(async () => {
        const queries = {
          limit: 5,
        }

        if (isNumeric(inputValue)) {
          queries.mobilePhone =
            inputValue[0] === "0"
              ? inputValue.substring(1)
              : inputValue
        } else {
          queries.fullName = inputValue

          queries.username = inputValue
        }

        const { data: users } =
          await getUserList(queries)

        callback(users.map(user => ({
          label: `${user.fullName} ${user.mobilePhone ? `(${formatMobilePhone(user.mobilePhone)})` : ""}`,
          value: user._id
        })))
      }, 600)
  }

  return (
    <div className={classes["container"]}>
      <Select
        async
        isClearable
        label={t("جست_و_جوی_مشتری")}
        loadOptions={handleSearch}
        value={form.account}
        noOptionsMessage={() => null}
        onChange={handleSelect}
        defaultOptions={initialUsersList}
        onFocus={getInitialUsersList}
      />
    </div>
  )
}

export default OfsUserSelect